module.exports = __webpack_public_path__ + "static/img/cont_01_m.617b8f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/relay-event/cont_01_m.jpg
// module id = 9vof
// module chunks = 0